var render = function render(){var _vm=this,_c=_vm._self._c;return _c('crud-page',{attrs:{"icon":"mdi-clipboard-list-outline","title":"Inspections"}},[_c('paginated-result-loader',{attrs:{"enable-exports":true,"namespace":"inspections"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('inspection-list',{attrs:{"full":true,"items":props.items}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }